import "slick-carousel"

export default {
	init() {

		const $slider = $('.slider-restaurant-gallery')

		// Restaurant gallery slider
		$slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			nextArrow: '<div class="slider-next"></div>',
			prevArrow: '<div class="slider-prev"></div>',
			dots: false,
		})

	}
}
